import { NgModule } from "@angular/core";
import { RaskCommonModule } from "../../../common/rask-common.module";
import { MattslagskonverteringComponent } from "./mattslagskonvertering.component";
import { MattslagskonverteringService } from "./mattslagskonvertering.service";

@NgModule({
    imports: [
        RaskCommonModule,
        MattslagskonverteringComponent
    ],
    providers: [MattslagskonverteringService]
})

export class MattslagskonverteringModule { }
